import { CircleAlertIcon } from "lucide-react"

import { Locale } from "@/types/nango"

const translation: Record<string, { EN: string; FR: string }> = {
  corrections: { EN: "Possible fixes:", FR: "Corrections possibles :" },
}

export default function ErrorBanner({
  errorMessage,
  fixes,
  locale = "FR",
}: {
  errorMessage: string
  fixes: string[]
  locale?: Locale
}) {
  return (
    <div className="border-destructive/50 text-destructive my-4 rounded-md border px-4 py-3">
      <div className="flex gap-3">
        <CircleAlertIcon
          className="mt-0.5 shrink-0 opacity-60"
          size={16}
          aria-hidden="true"
        />
        <div className="grow space-y-1">
          <p className="text-sm font-medium">{errorMessage}</p>
          <p className="text-sm opacity-80">
            {translation.corrections[locale]}
          </p>
          <ul className="list-inside list-disc text-sm opacity-80">
            {fixes.map((fix, index) => (
              <li key={index}>{fix}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
